<template>
  <div>
    <el-menu class='navbar' mode='horizontal'>
      <!--<hamburger class='hamburger-container' :toggleClick='toggleSideBar' :isActive='sidebar.opened'></hamburger>-->

      <tabs-view></tabs-view>

      <img src="~images/icon_logo.png" style="height:32px;margin-top:7px;float:left;margin-left:32px;">
      <div style="float:left;margin-left:20px;color:white">智能营销服务平台</div>
      
      <el-dropdown trigger='hover' placement="top-start">
        <div style="width:20px;">
          <img src="~images/icon_more.png" style="height:13px;margin-top:16px;">
        </div>
        
        <el-dropdown-menu slot='dropdown' style="width:150px;" >
          <template v-for="item in permission_routers">
            <el-dropdown-item v-if="!item.hidden">
              <router-link :to="item.path +'/'+item.children[0].path" >
                <span style='display:block;'>{{item.name}}</span>
              </router-link>
            </el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </el-dropdown>


      <el-dropdown class='avatar-container' trigger='hover'>
        <div class='avatar-wrapper'>
          <div style="float:left;">
            <img src="~images/icon_head.png" style="height:25px;margin-top:12px;">
          </div>
          <span class="account">{{userName}}</span>
          <i class='el-icon-caret-bottom'></i>
        </div>

        <el-dropdown-menu style="width:150px;" slot='dropdown'>
          <el-dropdown-item>
            <span style='display:block;' @click='accountSetting'>账户设置</span>
          </el-dropdown-item>

          <el-dropdown-item>
            <span style='display:block;' @click='authorizeManage'>授权管理</span>
          </el-dropdown-item>

          <el-dropdown-item divided>
            <span style='display:block;' @click='logout'>注销</span>
          </el-dropdown-item>
        </el-dropdown-menu>

        <!-- <span class="account-logout" @click='logout' style=" position: absolute;top: 0px;cursor:pointer;
          right: 0px;">退出</span> -->
      </el-dropdown>
    <!-- <div class="mod-nav-menu">
      <Levelbar class="bar"></Levelbar>
    </div> -->
    </el-menu>
    <el-dialog
      :visible.sync="pwdFlag"
      width="30%">
      <el-form :inline="true" label-width="100px" class="demo-form-inline" :model="setPwdForm" :rules="setPwdRules" ref="setPwdForm">
        <p class='setpwd-title'>账户设置</p>
        
        <el-form-item prop="userName" label="用户名:">
          <el-input name="userName" v-model="userName" disabled="true" placeholder="" />
        </el-form-item>

        <el-form-item prop="oldPwd" label="旧密码:">
          <el-input name="oldPwd" :type="'passWord'" v-model="setPwdForm.oldPwd" placeholder="请输入6-18位密码" />
        </el-form-item>

        <el-form-item prop="newPwd" label="新密码:">
          <el-input name="newPwd" :type="'passWord'" v-model="setPwdForm.newPwd" placeholder="请输入6-18位密码" />
        </el-form-item>

        <el-form-item prop="newPwd2" label="确认密码:">
          <el-input name="newPwd2" :type="'passWord'" v-model="setPwdForm.newPwd2" placeholder="请输入6-18位密码" />
        </el-form-item>
        <br/>
        <el-form-item style="text-align:center;width:100%;margin-top:10px;">
          <el-button style="width:130px;" type="primary" @click="setCserPwd()">提&nbsp;&nbsp;&nbsp;&nbsp;交</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>

    <el-dialog
      :visible.sync="showAuthorize"
      width="40%">
      <Authorize :isOpen="showAuthorize">
      </Authorize>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Levelbar from "./Levelbar";
import TabsView from "./TabsView";
import Authorize from '@/views/wechat/authorize';
import { getUserAccountId, getUserId, getUserName } from "@/utils/cookie";
import md5 from 'js-md5';

export default {
  components: {
    Levelbar,
    TabsView,
    Authorize
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.setPwdForm.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userAccountId: "",
      userId: "",
      userName: "",
      pwdFlag: false,
      showAuthorize: false,
      setPwdRules: {
				oldPwd: [
					{ required: true, message: '请输入旧密码', trigger: 'blur' },
					{ min: 6, max: 18, message: '请输入6-18位密码', trigger: 'blur' }
				],
				newPwd: [
					{ required: true, message: '请输入新密码', trigger: 'blur' },
					{ min: 6, max: 18, message: '请输入6-18位密码', trigger: 'blur' }
				],
				newPwd2: [{
					required: true,
					trigger: 'blur',
					validator: validatePass2
				}]
      },
      setPwdForm: {
				oldPwd: '',
				newPwd: '',
				newPwd2: ''
			},
    };
  },
  computed: {
    ...mapGetters(["permission_routers", "sidebar", "name", "avatar"])
  },
  created() {
    this.userAccountId = getUserAccountId();
    this.userId = getUserId();
    this.userName = getUserName();
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("FedLogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    home() {
      window.location.href = "/home.html";
    },
    accountSetting() {
      this.pwdFlag = true;
    },
    authorizeManage() {
      this.showAuthorize = true;
    },
    // 设置密码
    setCserPwd() {
			let _this = this;
			this.$refs.setPwdForm.validate((valid) => {
				if (valid) {
          var timestamp = Math.round(new Date().getTime()/1000) ;
          let pwdInfo = {
            loginName: this.userId,
						passwd: md5(md5(this.userId + _this.setPwdForm.oldPwd) + timestamp),
						newPwd: md5(this.userId + _this.setPwdForm.newPwd),
						timestamp: timestamp
          }
          this.$store.dispatch("setpwd", pwdInfo).then(() => {
            _this.pwdFlag = false
            _this.$message.success('修改成功。')
          });
				}
			});
    }
  }
};
</script>

<style rel='stylesheet/scss' lang='scss' scoped>
.setpwd-title {
  text-align: center;
  font-size: 18px;
  color:rgba(54,61,177,1);
  margin-bottom: 20px;
}
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  position: fixed;
  top: 0;
  left: 0px;
  right: 0;
  z-index: 999;
  background: url(https://cdn.greatdata.com.cn/oss/imc/main_top.png) no-repeat
    center;
  background-size: 100% 100%;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .navbar .avatar-container {
    color: #fff;
  }
  .mod-nav-menu {
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    padding-left: 20px;
    background: #ffffff;
  }
  
  .bar {
    position: absolute;
    right: 40px;
    top: 45px;
  }
  .errLog-container {
    display: inline-block;
    position: absolute;
    right: 50px;
  }
  .screenfull {
    position: absolute;
    right: 10px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 40px;
    color: #fff;
    .avatar-wrapper {
      cursor: pointer;
      /*margin-top: 5px;*/
      margin-right: 30px;
      position: relative;
      right: 65px;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 19px;
        font-size: 12px;
      }
      .account {
        padding-left: 10px;
      }
    }
  }
}
</style>






// WEBPACK FOOTER //
// Navbar.vue?44b04f46